import VueGtm from "vue-gtm";
import router from "../router";
import Vue from "vue";

Vue.use(VueGtm, {
  enabled: true,
  loadScript: false,
  vueRouter: router,
});
